import cx from 'classnames';
import './FieldGroup.css';

/**
 * QHS FieldGroup v2
 * -----------------
 * Card-based form section. Replaces legacy "title + blue line" dividers.
 *
 *   <FieldGroup title="Personal Information" description="Used for...">
 *     <FieldGroup.Grid columns={3}>
 *       <Input label="MRN" />
 *       <Input label="First Name" />
 *       <Input label="Last Name" />
 *     </FieldGroup.Grid>
 *   </FieldGroup>
 */
const FieldGroup = ({ title, description, actions, className, children, ...rest }) => (
  <section className={cx('qhs-fg', className)} {...rest}>
    {(title || description || actions) && (
      <header className="qhs-fg__head">
        <div className="qhs-fg__titles">
          {title && <h4 className="qhs-fg__title">{title}</h4>}
          {description && <p className="qhs-fg__desc">{description}</p>}
        </div>
        {actions && <div className="qhs-fg__actions">{actions}</div>}
      </header>
    )}
    <div className="qhs-fg__body">{children}</div>
  </section>
);

const Grid = ({ columns = 2, gap = 14, className, children, style, ...rest }) => (
  <div
    className={cx('qhs-fg__grid', `qhs-fg__grid--${columns}`, className)}
    style={{ gap, ...style }}
    {...rest}
  >
    {children}
  </div>
);
FieldGroup.Grid = Grid;

export default FieldGroup;
